import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';

async function syncPythonPackages(): Promise<void> {
  await post('/api/organizations/sync-python-packages', {});
}

/**
 * Hook to sync Python packages (shared by all orgs).
 * @returns Mutation function to trigger Python packages sync
 */
export const useSyncPythonPackages = () => {
  return useToastedMutation({
    mutationFn: syncPythonPackages,
    successToastMessage: 'SyncPythonPackages job queued successfully',
    errorToastMessage: 'Failed to queue SyncPythonPackages job',
  });
};
